<button type="button" class="btn-close sign-in-close-btn" (click)="activeModal.close()"></button>
<div class="modal-body">
  @switch (type) {
  @case (type == 'login' ? 'login' : type == 'register' ? 'register' : '') {
  <div class="d-flex align-items-center justify-content-center">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
      <li [ngbNavItem]="1">
        <button ngbNavLink>Sign in</button>
        <ng-template ngbNavContent>
          <app-login (type)="type=$event" />
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <button ngbNavLink>Register</button>
        <ng-template ngbNavContent>
          <app-register (type)="type=$event" />
        </ng-template>
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class=""></div>
  }
  @case ('forgot-password') {
  <app-forgot-password (type)="type=$event" />
  }
  @case ('reset-password') {
  <app-reset-password (type)="type=$event" />
  }
  @case ('verification') {
  <app-verify-account (type)="type=$event; active=2" />
  }
  @case ('change-password') {
  <app-update-password />
  }
  }

</div>
